import React from 'react';
import './HeaderSectionComponent.less';

function HeaderSectionComponent({title, subtitle, titleClass}) {
    let content = '';
    if (subtitle) {
        content = (
            <div>
                <p className="Owner">{title}</p>
                <p className="subheader">{subtitle}</p>
            </div>
        );
    } else if (titleClass) {
        content = (<h2 className={titleClass}>{title}</h2>);
    } else {
        content = (<h2 className="DefaultHeader">{title}</h2>);
    }
    return (
        <div className="HeaderSection">
            {content}
        </div>
    );
}

export default HeaderSectionComponent;
